import { Element } from '../../../../common/html/element'
import { CriteriaGroupTab } from './CriteriaGroupTabs'
import classes from './index.module.scss'
import { SearchCriteria } from './SearchCriteria'

export const SideContent = () => {
  return (
    <Element
      className={classes.sideContent}
      style={{
        borderColor: '#D5D5D5',
        backgroundColor: '#F3F3F3',
      }}
    >
      <SearchCriteria />
      <CriteriaGroupTab />
    </Element>
  )
}
